import { useState } from 'react';

import { Technology } from 'modules/chains/constants';

export const useTechnology = () => useState(Technology.CURL);
